import common from './common.json';
import auth from './auth.json';
import home from './home.json';
import workoutPartners from './workoutPartners.json';
import dashboard from './dashboard.json';
import settings from './settings.json';
import formFields from './formFields.json';
import userSettings from './userSettings.json';
import bookings from './bookings.json';
import walkthrough from './walkthrough.json';
import contactUs from './contactUs.json';
import payments from './payments.json';
import nutrition from './nutrition.json';
import workoutHistory from './workoutHistory.json';
import workoutGoals from './workoutGoals.json';
import stats from './stats.json';
import tracking from './tracking.json';
import homeWorkouts from './homeWorkouts.json';
import bodyscan from './bodyscan.json';
import heartRateDevice from './heartRateDevice.json';
import weightTarget from './weightTarget.json';
import elite from './elite.json';
import familyPlan from './familyPlan.json';
import strengthAssessment from './strengthAssessment.json';
import user from './user.json';

export default {
  common,
  auth,
  home,
  workoutPartners,
  dashboard,
  settings,
  formFields,
  userSettings,
  bookings,
  walkthrough,
  contactUs,
  payments,
  nutrition,
  workoutHistory,
  workoutGoals,
  stats,
  tracking,
  homeWorkouts,
  bodyscan,
  heartRateDevice,
  weightTarget,
  elite,
  familyPlan,
  strengthAssessment,
  user,
};
